import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import BackgroundImg from "../assets/images/TehnologyManagementImg.png";
import GetInTouch from "../components/getInTouchComponent/getInTouchComponent";
import "./styles.scss";
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
import TehnologyManagementCardContent from "../components/tehnologyManagementComponents/tehnologyManagementContent";

const TehnologyManagementPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground
        insideText={"Tehnology Management"}
        imgPath={BackgroundImg}
      />
      <TehnologyManagementCardContent />
      <GetInTouch />
      <TestimonialsTravala />
    </div>
  );
};

export default TehnologyManagementPage;
